import api from './api';

export const addonService = {
  async getAddons() {
    const response = await api.get('/addons');
    return response.data;
  },

  async getAddonItem(id) {
    const response = await api.get(`/addons/items/${id}`);
    return response.data.data;
  },

  async createAddonItem(data) {
    const response = await api.post('/addons/items', data);
    return response.data.data;
  },

  async updateAddonItem(id, data) {
    const response = await api.put(`/addons/items/${id}`, data);
    return response.data.data;
  },

  async updateAddonCategory(id, data) {
    const response = await api.put(`/addons/categories/${id}`, data);
    return response.data.data;
  },

  async createAddonCategory(data) {
    const response = await api.post('/addons/categories', data);
    return response.data.data;
  },

  async deleteAddonCategory(id) {
    const response = await api.delete(`/addons/categories/${id}`);
    return response.data.data;
  },

  async deleteAddonItem(id) {
    const response = await api.delete(`/addons/items/${id}`);
    return response.data.data;
  },
};